import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '../utils/analytics';

/**
 * Sends a GA4 page_view on every route change (and on initial load).
 * Renders nothing; mount once inside the Router.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
